import { createContext, useContext, useEffect, useState } from 'react';
import { applyTheme, getTheme } from '../styles/themes';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [tenantId, setTenantId] = useState(
    () => localStorage.getItem('starfuel_tenant') || 'starfuel'
  );

  useEffect(() => {
    applyTheme(tenantId);
    localStorage.setItem('starfuel_tenant', tenantId);

    // Load Google Fonts
    const link = document.createElement('link');
    link.href =
      'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600;700&family=JetBrains+Mono&display=swap';
    link.rel = 'stylesheet';
    if (!document.querySelector('link[href*="Bebas+Neue"]')) {
      document.head.appendChild(link);
    }
  }, [tenantId]);

  const theme = getTheme(tenantId);

  return (
    <ThemeContext.Provider value={{ tenantId, setTenantId, theme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
